import React from 'react';
import { Form, FormControl, FormGroup, Grid, Row, Col, Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setUserData } from '../redux/actionCreators';
import Validator from './Validation/Validator';
import ValidatedField from './Validation/ValidatedField';
import Api from '../api/api';

class Support extends React.Component {
  state = {
    data: {
      name: '',
      email: '',
      message: '',
    },
    errors: [],
    statusMessage: {
      type: '',
      text: '',
    },
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    !this.props.user.id && Api.users.getUserPersonalData().then(user => this.props.setUserData(user));
  }

  componentDidUpdate() {
    const alert = this.refs.supportStatusMessage;

    alert && setTimeout(() => this.setState({ statusMessage: { type: '', text: '' } }), 5000);
  }

  validator = this.props.authenticated
    ? new Validator({
        message: [Validator.required],
      })
    : new Validator({
        name: [Validator.required, Validator.noForbiddenSigns],
        email: [Validator.required, Validator.email],
        message: [Validator.required],
      });

  handleInputChange = e => this.setState({ data: { ...this.state.data, [e.target.name]: e.target.value } });

  clearMessage = () =>
    this.setState({
      statusMessage: {
        type: '',
        text: '',
      },
    });

  handleFormSubmit = e => {
    e.preventDefault();

    const { authenticated, user } = this.props;
    const { data } = this.state;

    this.setState({ errors: [] }, () => {
      const errors = authenticated ? this.validator.validate({ message: data.message }) : this.validator.validate(data);

      if (errors.length) {
        this.setState({ errors });
      } else {
        const requestData = authenticated
          ? { name: `${user.first_name} ${user.last_name}`, email: user.email, message: data.message }
          : { name: data.name, email: data.email, message: data.message };

        Api.users
          .sendSupportMessage({ support: requestData })
          .then(() =>
            this.setState({
              data: {
                name: '',
                email: '',
                message: '',
              },
              statusMessage: { type: 'success', text: 'Your message has been sent successfully' },
            }),
          )
          .catch(() => this.setState({ statusMessage: { type: 'danger', text: 'Unknown error has occured' } }));
      }
    });
  };

  render() {
    const { authenticated, history } = this.props;
    const {
      data: { name, email, message },
      errors,
      statusMessage: { type, text },
    } = this.state;

    return (
      <Grid className="main-fullheight">
        <div className="fullheight">
          {!!text && (
            <Alert bsStyle={type} id="getintouchAlert" ref="supportStatusMessage" onDismiss={this.clearMessage}>
              <span className="png-ok-circle" />
              <span className="text-alert">{text}</span>
            </Alert>
          )}
          <Row className="show-grid">
            <Col md={12} className="width-1015">
              <Row>
                <Col md={5}>
                  <h2 className="heading hd-left">Get In Touch</h2>
                </Col>
                <Col md={7}>
                  <p className="description-form get-touch">
                    We’re eager to hear your questions, comments, and experiences regarding the Presence app. Contact
                    us, and we’ll get back to you as soon as possible.
                  </p>
                </Col>
              </Row>
              <Row className="show-grid second-row">
                <Col md={5}>
                  <p className="description-contact">Contact Us</p>
                  {/*<p className="first-point main-point">*/}
                  {/*Phone: <span className="phone-email">309 736 54 77</span>*/}
                  {/*</p>*/}
                  <p className="first-point">
                    Email: <span className="phone-email">support@presence.app</span>
                  </p>
                  <p className="first-point policy terms-service">
                    <a onClick={() => history.push('/terms-of-service')} className="phone-email">
                      Terms of Service
                    </a>
                  </p>
                  <p className="first-point policy cookie-policy">
                    <a onClick={() => history.push('/cookie-policy')} className="phone-email">
                      Cookie Policy
                    </a>
                  </p>
                </Col>
                <Col md={7}>
                  <p className="description-contact">Send a message</p>
                  <Form>
                    {!authenticated && (
                      <Row className="show-grid">
                        <Col md={6}>
                          <FormGroup>
                            <ValidatedField field="name" errors={errors}>
                              <FormControl
                                value={name}
                                onChange={this.handleInputChange}
                                name="name"
                                type="text"
                                placeholder="Your Name"
                                autoComplete="name"
                              />
                            </ValidatedField>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <ValidatedField field="email" errors={errors}>
                              <FormControl
                                value={email}
                                onChange={this.handleInputChange}
                                name="email"
                                type="email"
                                placeholder="Email Address"
                                autoComplete="email"
                              />
                            </ValidatedField>
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                    <Row className="show-grid">
                      <Col md={12}>
                        <FormGroup className="textarea-field">
                          <ValidatedField field="message" errors={errors}>
                            <FormControl
                              value={message}
                              onChange={this.handleInputChange}
                              name="message"
                              componentClass="textarea"
                              placeholder="Type your message"
                            />
                          </ValidatedField>
                        </FormGroup>
                      </Col>
                      <Col md={6} />
                      <Col md={6}>
                        <div className="white-submit">
                          <Button onClick={this.handleFormSubmit} bsStyle="primary">
                            Send
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({ authenticated: state.session.authenticated, user: state.user });

const mapDispatchToProps = (dispatch: Function) => ({
  setUserData(user) {
    dispatch(setUserData(user));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Support);



// WEBPACK FOOTER //
// ./src/components/Support.js